import {Participant} from "./Chat";
export type RequestStatus = "open"|"approved"|"declined"|"cancelled";
export type RequestEvent = {
    createTime: number
    user: string
    title: string
};
export type Request = {
    approver: string
    chatID: string
    createTime: number
    creator: string
    description: string
    events?: RequestEvent[]
    loadID?: string
    note?: string
    participants: Participant[]
    requestID: string
    recipients: string[]
    status: RequestStatus
    title: string
};
export type Verification = {
    VerificationID: string
    intent: "CREATION"|"REASSIGNMENT"|"CANCELLATION"|"RESOLUTION"
};
type RequestAPIResponse = {
    chatID: string
    createdAt: string
    creatorEmail: string
    description: string
    note?: string
    requestID: string
    recipients: string[]
    resolverEmail: string
    status: Request["status"]
    title: string
};

const RequestAPIResponse = {
    toRequest(val: RequestAPIResponse): Request {
        return {
            approver: val.resolverEmail,
            chatID: val.chatID,
            createTime: new Date(val.createdAt).getTime(),
            creator: val.creatorEmail,
            description: val.description,
            note: val.note,
            participants: val.recipients.concat(
                [val.resolverEmail, val.creatorEmail]
            ).map(function (email) {
                return {type: "non-existent", data: {email}};
            }),
            requestID: val.requestID,
            recipients: val.recipients,
            status: val.status,
            title: val.title,
        };
    }
}

export {RequestAPIResponse};
